import { MT_ENTERPRISES } from '../mtEnterprises';

// The standalone calendar page for multi-tenant enterprises. Other route sets
// (mcd/standard/commsHub/th) register the shared `calendarRoute`; multiClient
// follows the per-feature module convention (like sales/people/labor). This
// registers the route so `/calendar` RESOLVES 
const routes = {
  name: 'Calendar',
  nameES: 'Calendario',
  icon: 'mdi-calendar',
  path: '/calendar',
  meta: { hidePageHeader: true },
  component: () =>
    import('@/views/dashboard/widgets/calendar/ui/calendar_view.vue'),
  // MT-only sidebar entry (no McDonald's ZA equivalent — calendar birthdays are
  // an MT-pipeline feature). Plain `TimHortons` is excluded by omission from
  // mtEnterprises.js.
  menuFilters: {
    $and: [
      { countryCode: { $in: ['us', 'ca'] } },
      { enterpriseClient: { $in: MT_ENTERPRISES } },
    ],
  },
};

export default routes;
